import { type ReportTemplate } from 'reportingSolution/constants'

const config: ReportTemplate = {
  id: 'reporting_base',
  active: true,
  label: 'Precis Starter Report',
  category: 'Getting started',
  description: 'The Precis starter report',
  image_url:
    'https://lh3.googleusercontent.com/drive-viewer/AITFw-wj9qpz05mT06UiOukz0t2lm73qa-WFfL5ClHvM_EHQw5GIf6E-PK0ceylbSgiyvA0BIVauHSmrmIMe7Cv74OTZfOMhBQ=s1600',
  authors: [
    {
      name: 'Tobias Hink',
      email: 'hink@precisdigital.com',
      image_url: 'https://lh3.googleusercontent.com/a-/AOh14GjyNEc4WJk3HgY11avoS-2opMitZKNbLBZcaWvS=s126-p-k-rw-no'
    },
    {
      name: 'Jonas Bæk',
      email: 'jonas@precisdigital.com',
      image_url: 'https://lh3.googleusercontent.com/ogw/AOLn63HCWKXxP5vd6YL-Mw1-yI8FZQ-5i7IZ3Cp6pWV8cg=s256-c-mo'
    },
    {
      name: 'Joella Berg',
      email: 'joella@precisdigital.com',
      image_url: 'https://drive.google.com/uc?id=1uX3nOAOFswYoVXn3gqg3DErkA4xEC2uY'
    }
  ],
  documentation: {
    type: 'knowledge_hub',
    link: 'https://help.alvie.io/en/articles/174312-precis-starter-report-overview',
    link_description: 'Knowledge Hub: The Precis Starter Report'
  },
  dashboard: {
    template_report_id: '2b571818-35d5-400f-824f-fb2b940888c0',
    report_name_template: 'copy of Precis Starter Report - {today}',
    datasources: [
      {
        alias: 'base',
        datasourceName: 'Base - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'gads',
        datasourceName: 'Google Ads - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_gads_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'bing',
        datasourceName: 'Bing - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_bing_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'facebook',
        datasourceName: 'Facebook - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_facebook_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'dv360',
        datasourceName: 'DV360 - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_dv360_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'ga',
        datasourceName: 'GA - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_ga_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'tiktok',
        datasourceName: 'tiktok - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_tiktok_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'snapchat',
        datasourceName: 'snapchat - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_snapchat_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'linkedin',
        datasourceName: 'linkedin - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_linkedin_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'all_analytics',
        datasourceName: 'all analytics data - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_all_analytics_data_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'all_marketing',
        datasourceName: 'all marketing data - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_all_marketing_data_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'gsc',
        datasourceName: 'Google Search Console - {name}',
        type: 'TABLE',
        tableId: 'reporting_base_search_console_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'ga4_lp',
        type: 'CUSTOM',
        datasourceName: 'GA4 Landing pages - {name}',
        sqlReplace:
          'precis-internal-group-central,{project_id},reporting_base_test,{dataset_id},test_reporting_base,{name}'
      }
    ]
  },
  sources: {
    ga4: {
      reports: [
        'ga4_session_scoped_attribution',
        'ga4_event_scoped_attribution',
        'sessions_reporting_base',
        'lnda_campaign_conversion_base',
        'dda_campaign_conversion_base',
        'campaign_sessions_base',
        'landing_page_conversions',
        'landing_page_sessions'
      ],
      optional: true
    },
    google_analytics: {
      reports: ['campaign_performance_core'],
      optional: true
    },
    gads: {
      reports: ['campaign_performance_base', 'campaign_conversion_expanded'],
      optional: true
    },
    bing: {
      reports: ['campaign_performance_base'],
      optional: true
    },
    facebook: {
      reports: ['ad_performance', 'ad_performance_country'],
      optional: true
    },
    dv360: {
      reports: ['campaign_performance_core'],
      optional: true
    },
    linkedin_ads: {
      reports: ['campaign_conversion_base', 'campaign_performance'],
      optional: true
    },
    tiktok: {
      reports: ['ad_performance_base', 'ad_performance_custom_conversions'],
      optional: true
    },
    snapchat: {
      reports: ['campaign_performance_base'],
      optional: true
    },
    criteo: {
      reports: ['ad_group_performance'],
      optional: true,
      hidden: false
    },
    pinterest: {
      reports: ['ad_group_country_performance'],
      optional: true,
      hidden: false
    },
    amazon: {
      reports: ['unified_campaign_daily_report'],
      optional: true,
      hidden: false
    },
    google_sheets: {
      reports: ['budget_base'],
      optional: true
    },
    google_search_console: {
      reports: ['page_query_all_dimensions', 'property_all_dimensions'],
      optional: true
    },
    chatgpt_ads: {
      reports: ['ad_performance_base'],
      optional: true,
      internalOnly: true
    }
  },
  inputs: {
    ga4: [
      {
        id: 'ga4CustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Google Analytics 4.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Property name',
            value: 'property_name',
            type: 'string'
          },
          {
            label: 'Account name (Property Name)',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Property ID',
            value: 'property_id',
            type: 'string'
          },
          {
            label: 'Stream name',
            value: 'streamName',
            type: 'string'
          },
          {
            label: 'Stream ID',
            value: 'streamId',
            type: 'string'
          },
          {
            label: 'Hostname',
            value: 'hostname',
            type: 'string'
          },
          {
            label: 'Source',
            value: 'source',
            type: 'string'
          },
          {
            label: 'Medium',
            value: 'medium',
            type: 'string'
          },
          {
            label: 'Source / Medium',
            value: 'source_medium',
            type: 'string'
          },
          {
            label: 'Campaign',
            value: 'campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Direct',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: '(direct)'
                }
              ]
            }
          },
          {
            name: 'Affiliates',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'medium',
                  value: 'affiliate'
                }
              ]
            }
          },
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'display / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'remarketing'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'display / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'prospecting'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'display'
                }
              ]
            }
          },
          {
            name: 'Organic Search',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'google'
                },
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'bing'
                },
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'yahoo'
                },
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'duckduckgo'
                }
              ],
              '1': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'organic'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Brand',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'bing / cpc'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'brand'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Shopping',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'bing / cpc'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'shopping'
                }
              ]
            }
          },
          {
            name: 'Paid Search - PMax',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'pmax'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'performance max'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'google / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'bing / cpc'
                }
              ]
            }
          },
          {
            name: 'Paid Social - Retargeting',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'facebook / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'facebook / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'pinterest / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'pinterest / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'tiktok / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'tiktok / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'snapchat / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'snapchat / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'linkedin / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'linkedin / cpm'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'retargeting'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'remarketing'
                }
              ]
            }
          },
          {
            name: 'Paid Social - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'facebook / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'facebook / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'pinterest / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'pinterest / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'tiktok / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'tiktok / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'snapchat / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'snapchat / cpm'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'linkedin / cpc'
                },
                {
                  operator: 'equals',
                  dimension: 'source_medium',
                  value: 'linkedin / cpm'
                }
              ]
            }
          },
          {
            name: 'Organic Social',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'facebook'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'instagram'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'pinterest'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'snapchat'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'tiktok'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'linkedin'
                }
              ]
            }
          },
          {
            name: 'Email',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'email'
                }
              ]
            }
          },
          {
            name: 'Referral',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'referral'
                }
              ]
            }
          },
          {
            name: 'Price Comparison Sites',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'idealo'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'billiger'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'kelkoo'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'bestcheck'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'pricerunner'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'prisjakt'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'ga4MarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Google Analytics 4.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Property name',
            value: 'property_name',
            type: 'string'
          },
          {
            label: 'Account name (Property Name)',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Property ID',
            value: 'property_id',
            type: 'string'
          },
          {
            label: 'Stream name',
            value: 'streamName',
            type: 'string'
          },
          {
            label: 'Stream ID',
            value: 'streamId',
            type: 'string'
          },
          {
            label: 'Hostname',
            value: 'hostname',
            type: 'string'
          },
          {
            label: 'Source',
            value: 'source',
            type: 'string'
          },
          {
            label: 'Medium',
            value: 'medium',
            type: 'string'
          },
          {
            label: 'Source / Medium',
            value: 'source_medium',
            type: 'string'
          },
          {
            label: 'Campaign',
            value: 'campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-dk-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'denmark'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-se-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'sweden'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-no-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'norway'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-fi-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'finland'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-de-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'germany'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    google_analytics: [
      {
        id: 'googleAnalyticsCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Google Analytics.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Property ID',
            value: 'web_property_id',
            type: 'string'
          },
          {
            label: 'View name',
            value: 'profile_name',
            type: 'string'
          },
          {
            label: 'View ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Hostname',
            value: 'hostname',
            type: 'string'
          },
          {
            label: 'Source',
            value: 'source',
            type: 'string'
          },
          {
            label: 'Medium',
            value: 'medium',
            type: 'string'
          },
          {
            label: 'Source / Medium',
            value: 'source_medium',
            type: 'string'
          },
          {
            label: 'Campaign',
            value: 'campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'adwordsCampaignId',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Direct',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: '(direct)'
                }
              ]
            }
          },
          {
            name: 'Affiliates',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'medium',
                  value: 'affiliate'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'google'
                }
              ],
              '1': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'CPC'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'source',
                  value: 'bing'
                }
              ],
              '1': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'CPC'
                }
              ]
            }
          },
          {
            name: 'Organic Social',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'facebook'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'instagram'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'pinterest'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'snapchat'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'tiktok'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'linkedin'
                }
              ]
            }
          },
          {
            name: 'Email',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'email'
                }
              ]
            }
          },
          {
            name: 'Referral',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'medium',
                  value: 'referral'
                }
              ]
            }
          },
          {
            name: 'Price Comparison Sites',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'idealo'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'billiger'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'kelkoo'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'bestcheck'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'pricerunner'
                },
                {
                  operator: 'contains',
                  dimension: 'source',
                  value: 'prisjakt'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'googleAnalyticsMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Google Analytics.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Property ID',
            value: 'web_property_id',
            type: 'string'
          },
          {
            label: 'View name',
            value: 'profile_name',
            type: 'string'
          },
          {
            label: 'View ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Hostname',
            value: 'hostname',
            type: 'string'
          },
          {
            label: 'Source',
            value: 'source',
            type: 'string'
          },
          {
            label: 'Medium',
            value: 'medium',
            type: 'string'
          },
          {
            label: 'Source / Medium',
            value: 'source_medium',
            type: 'string'
          },
          {
            label: 'Campaign',
            value: 'campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'adwordsCampaignId',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-dk-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'denmark'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-se-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'sweden'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-no-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'norway'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-fi-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'finland'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'hostname',
                  value: '.de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: '-de-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'germany'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    gads: [
      {
        id: 'gadsCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Google Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'customer__descriptive_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'customer__id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign__name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign__id',
            type: 'string'
          },
          {
            label: 'Campaign status',
            value: 'campaign__status',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign__advertising_channel_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign__advertising_channel_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'display'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'display'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Brand',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'brand'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Shopping',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'shopping'
                }
              ]
            }
          },
          {
            name: 'Paid Search - PMax',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'pmax'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'performance max'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'not_equals',
                  dimension: 'campaign__name',
                  value: 'everything else'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'gadsMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Google Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'customer__descriptive_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'customer__id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign__name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign__id',
            type: 'string'
          },
          {
            label: 'Campaign status',
            value: 'campaign__status',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign__advertising_channel_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign__advertising_channel_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'global'
                }
              ]
            }
          },
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-de-'
                }
              ]
            }
          }
        ]
      }
    ],
    bing: [
      {
        id: 'bingCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Microsoft Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'AccountName',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AccountNumber',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'CampaignName',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CampaignId',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'CampaignType',
            type: 'string'
          },
          {
            label: 'Campaign ad distribution',
            value: 'AdDistribution',
            type: 'string'
          },
          {
            label: 'Network',
            value: 'Network',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'display'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'display'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Brand',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'brand'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Shopping',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'shopping'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'not_equals',
                  dimension: 'CampaignName',
                  value: 'everything else'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'bingMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Microsoft Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'AccountName',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AccountNumber',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'CampaignName',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CampaignId',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'CampaignType',
            type: 'string'
          },
          {
            label: 'Campaign ad distribution',
            value: 'AdDistribution',
            type: 'string'
          },
          {
            label: 'Network',
            value: 'Network',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'AccountName',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'CampaignName',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    facebook: [
      {
        id: 'facebookCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Meta Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign buying type',
            value: 'buying_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad set name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad set ID',
            value: 'adset_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Paid Social - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Paid Social - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'facebookMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Meta Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign buying type',
            value: 'buying_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad set name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad set ID',
            value: 'adset_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    dv360: [
      {
        id: 'dv360CustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in DV360.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Partner name',
            value: 'filter_partner_name',
            type: 'string'
          },
          {
            label: 'Partner ID',
            value: 'filter_partner',
            type: 'string'
          },
          {
            label: 'Advertiser name',
            value: 'filter_advertiser_name',
            type: 'string'
          },
          {
            label: 'Advertiser ID',
            value: 'filter_advertiser',
            type: 'string'
          },
          {
            value: 'filter_media_plan_name',
            label: 'Campaign Name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'filter_media_plan',
            type: 'string'
          },
          {
            label: 'Insertion order name',
            value: 'filter_insertion_order_name',
            type: 'string'
          },
          {
            label: 'Insertion order ID',
            value: 'filter_insertion_order',
            type: 'string'
          },
          {
            label: 'Line item name',
            value: 'filter_line_item_name',
            type: 'string'
          },
          {
            label: 'Line item ID',
            value: 'filter_line_item',
            type: 'string'
          },
          {
            label: 'Creative type',
            value: 'filter_creative_type',
            type: 'string'
          },
          {
            label: 'Position in content',
            value: 'filter_position_in_content',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'dv360MarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in DV360.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Partner name',
            value: 'filter_partner_name',
            type: 'string'
          },
          {
            label: 'Partner ID',
            value: 'filter_partner',
            type: 'string'
          },
          {
            label: 'Advertiser name',
            value: 'filter_advertiser_name',
            type: 'string'
          },
          {
            label: 'Advertiser ID',
            value: 'filter_advertiser',
            type: 'string'
          },
          {
            value: 'filter_media_plan_name',
            label: 'Campaign Name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'filter_media_plan',
            type: 'string'
          },
          {
            label: 'Insertion order name',
            value: 'filter_insertion_order_name',
            type: 'string'
          },
          {
            label: 'Insertion order ID',
            value: 'filter_insertion_order',
            type: 'string'
          },
          {
            label: 'Line item name',
            value: 'filter_line_item_name',
            type: 'string'
          },
          {
            label: 'Line item ID',
            value: 'filter_line_item',
            type: 'string'
          },
          {
            label: 'Creative type',
            value: 'filter_creative_type',
            type: 'string'
          },
          {
            label: 'Position in content',
            value: 'filter_position_in_content',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    tiktok: [
      {
        id: 'tiktokCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in TikTok.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'advertiser_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective_type',
            type: 'string'
          },
          {
            label: 'Campaign Dedicate Type',
            value: 'campaign_dedicate_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'tiktokMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in TikTok.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'advertiser_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective_type',
            type: 'string'
          },
          {
            label: 'Campaign Dedicate Type',
            value: 'campaign_dedicate_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    linkedin_ads: [
      {
        id: 'linkedinCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in LinkedIn.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'campaign_objective_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'linkedinMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in LinkedIn.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'campaign_objective_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    snapchat: [
      {
        id: 'snapchatCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Snapchat.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'snapchatMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Snapchat.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      }
    ],
    criteo: [
      {
        id: 'criteoCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Criteo.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'Advertiser',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AdvertiserId',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'Campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CampaignId',
            type: 'string'
          },
          {
            label: 'Objective',
            value: 'Objective',
            type: 'string'
          },
          {
            label: 'Media type',
            value: 'MediaType',
            type: 'string'
          },
          {
            label: 'Coupon',
            value: 'Coupon',
            type: 'string'
          },
          {
            label: 'Goal',
            value: 'Goal',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'Campaign',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'Campaign',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'Campaign',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'criteoMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Criteo.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'Advertiser',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AdvertiserId',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'Campaign',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CampaignId',
            type: 'string'
          },
          {
            label: 'Objective',
            value: 'Objective',
            type: 'string'
          },
          {
            label: 'Media type',
            value: 'MediaType',
            type: 'string'
          },
          {
            label: 'Coupon',
            value: 'Coupon',
            type: 'string'
          },
          {
            label: 'Goal',
            value: 'Goal',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'denmark' },
                { operator: 'contains', dimension: 'Advertiser', value: 'dk' },
                { operator: 'contains', dimension: 'Campaign', value: 'denmark' },
                { operator: 'contains', dimension: 'Campaign', value: '-dk-' }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'sweden' },
                { operator: 'contains', dimension: 'Advertiser', value: 'se' },
                { operator: 'contains', dimension: 'Campaign', value: 'sweden' },
                { operator: 'contains', dimension: 'Campaign', value: '-se-' }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'norway' },
                { operator: 'contains', dimension: 'Advertiser', value: 'no' },
                { operator: 'contains', dimension: 'Campaign', value: 'norway' },
                { operator: 'contains', dimension: 'Campaign', value: '-no-' }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'finland' },
                { operator: 'contains', dimension: 'Advertiser', value: 'fi' },
                { operator: 'contains', dimension: 'Campaign', value: 'finland' },
                { operator: 'contains', dimension: 'Campaign', value: '-fi-' }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'germany' },
                { operator: 'contains', dimension: 'Advertiser', value: 'de' },
                { operator: 'contains', dimension: 'Campaign', value: 'germany' },
                { operator: 'contains', dimension: 'Campaign', value: '-de-' }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'Advertiser', value: 'global' },
                { operator: 'contains', dimension: 'Campaign', value: 'global' }
              ]
            }
          }
        ]
      }
    ],
    pinterest: [
      {
        id: 'pinterestCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Pinterest.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'ACCOUNT_NAME',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AD_ACCOUNT_ID',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'CAMPAIGN_NAME',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CAMPAIGN_ID',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'CAMPAIGN_OBJECTIVE_TYPE',
            type: 'string'
          },
          {
            label: 'Ad group name',
            value: 'AD_GROUP_NAME',
            type: 'string'
          },
          {
            label: 'Ad group ID',
            value: 'AD_GROUP_ID',
            type: 'string'
          },
          {
            label: 'Targeting type',
            value: 'TARGETING_TYPE',
            type: 'string'
          },
          {
            label: 'Targeting value',
            value: 'TARGETING_VALUE',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CAMPAIGN_NAME',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'CAMPAIGN_NAME',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'CAMPAIGN_NAME',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'pinterestMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Pinterest.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'ACCOUNT_NAME',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'AD_ACCOUNT_ID',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'CAMPAIGN_NAME',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'CAMPAIGN_ID',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'CAMPAIGN_OBJECTIVE_TYPE',
            type: 'string'
          },
          {
            label: 'Ad group name',
            value: 'AD_GROUP_NAME',
            type: 'string'
          },
          {
            label: 'Ad group ID',
            value: 'AD_GROUP_ID',
            type: 'string'
          },
          {
            label: 'Targeting type',
            value: 'TARGETING_TYPE',
            type: 'string'
          },
          {
            label: 'Targeting value',
            value: 'TARGETING_VALUE',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'denmark' },
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'dk' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'denmark' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: '-dk-' }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'sweden' },
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'se' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'sweden' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: '-se-' }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'norway' },
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'no' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'norway' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: '-no-' }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'finland' },
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'fi' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'finland' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: '-fi-' }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'germany' },
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'de' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'germany' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: '-de-' }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'ACCOUNT_NAME', value: 'global' },
                { operator: 'contains', dimension: 'CAMPAIGN_NAME', value: 'global' }
              ]
            }
          }
        ]
      }
    ],
    amazon: [
      {
        id: 'amazonCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Amazon.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'amazonMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Amazon.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'denmark' },
                { operator: 'contains', dimension: 'account_name', value: 'dk' },
                { operator: 'contains', dimension: 'campaign_name', value: 'denmark' },
                { operator: 'contains', dimension: 'campaign_name', value: '-dk-' }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'sweden' },
                { operator: 'contains', dimension: 'account_name', value: 'se' },
                { operator: 'contains', dimension: 'campaign_name', value: 'sweden' },
                { operator: 'contains', dimension: 'campaign_name', value: '-se-' }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'norway' },
                { operator: 'contains', dimension: 'account_name', value: 'no' },
                { operator: 'contains', dimension: 'campaign_name', value: 'norway' },
                { operator: 'contains', dimension: 'campaign_name', value: '-no-' }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'finland' },
                { operator: 'contains', dimension: 'account_name', value: 'fi' },
                { operator: 'contains', dimension: 'campaign_name', value: 'finland' },
                { operator: 'contains', dimension: 'campaign_name', value: '-fi-' }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'germany' },
                { operator: 'contains', dimension: 'account_name', value: 'de' },
                { operator: 'contains', dimension: 'campaign_name', value: 'germany' },
                { operator: 'contains', dimension: 'campaign_name', value: '-de-' }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'global' },
                { operator: 'contains', dimension: 'campaign_name', value: 'global' }
              ]
            }
          }
        ]
      }
    ],
    google_search_console: [
      {
        id: 'gscCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Google Search Console.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Site URL',
            value: 'siteUrl',
            type: 'string'
          },
          {
            label: 'Query',
            value: 'query',
            type: 'string'
          },
          {
            label: 'Page',
            value: 'page',
            type: 'string'
          },
          {
            label: 'Country Code (ISO 3166-1 alpha-3)',
            value: 'country_iso_alpha_3',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          },
          {
            label: 'Device',
            value: 'device',
            type: 'string'
          },
          {
            label: 'Keyword type',
            value: 'brand_keyword_type',
            type: 'string'
          },
          {
            label: 'Ranking Range',
            value: 'ranking_range',
            type: 'string'
          },
          {
            label: 'Question Type',
            value: 'question_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Organic Search',
            rules: {
              '0': [
                {
                  operator: 'not_equals',
                  dimension: 'siteUrl',
                  value: 'not_a_real_site_url'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'gscMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Google Search Console.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Site URL',
            value: 'siteUrl',
            type: 'string'
          },
          {
            label: 'Query',
            value: 'query',
            type: 'string'
          },
          {
            label: 'Page',
            value: 'page',
            type: 'string'
          },
          {
            label: 'Country Code (ISO 3166-1 alpha-3)',
            value: 'country_iso_alpha_3',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          },
          {
            label: 'Device',
            value: 'device',
            type: 'string'
          },
          {
            label: 'Keyword type',
            value: 'brand_keyword_type',
            type: 'string'
          },
          {
            label: 'Ranking Range',
            value: 'ranking_range',
            type: 'string'
          },
          {
            label: 'Question Type',
            value: 'question_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'country_iso_alpha_3',
                  value: 'dnk'
                },
                {
                  operator: 'equals',
                  dimension: 'country',
                  value: 'denmark'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'country_iso_alpha_3',
                  value: 'swe'
                },
                {
                  operator: 'equals',
                  dimension: 'country',
                  value: 'sweden'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'country_iso_alpha_3',
                  value: 'nor'
                },
                {
                  operator: 'equals',
                  dimension: 'country',
                  value: 'norway'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'country_iso_alpha_3',
                  value: 'fin'
                },
                {
                  operator: 'equals',
                  dimension: 'country',
                  value: 'finland'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'country_iso_alpha_3',
                  value: 'deu'
                },
                {
                  operator: 'equals',
                  dimension: 'country',
                  value: 'germany'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'organicBrandFilter',
        type: 'string',
        label: 'Brand Keyword Type',
        helperText: 'A regex pattern to identify brand queries. Example: "mybrand|my brand|mybrand misspelled"',
        required: false,
        defaultValue: 'my brand|my brand mispelled',
        mutable: true,
        isRegex: true
      },
      {
        id: 'organicQuestionType',
        type: 'string',
        label: 'Question Type',
        helperText:
          'A regex pattern to match question queries. Example regex using whole words: "(^| )(what|who|where|when|why|how|is|are|do|does|can|could|should)( |$)"',
        required: false,
        defaultValue: '(^| )(what|who|where|when|why|how|is|are|do|does|can|could|should)( |$)',
        mutable: true,
        isRegex: true
      },
      {
        id: 'ga4Events',
        type: 'string',
        label: 'GA4 Event Name',
        helperText:
          'A regex pattern to match GA4 events you want to include in your report. Example: "purchase|add_to_cart" or "^purchase$". Only applies to ga4 landing page reports for search console.',
        required: false,
        defaultValue: 'purchase|add to cart',
        mutable: true,
        isRegex: true
      }
    ],
    chatgpt_ads: [
      {
        id: 'chatgptAdsCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in ChatGPT Ads.',
        required: false,
        mutable: true,
        dimensions: [
          { label: 'Account ID', value: 'account_id', type: 'string' },
          { label: 'Account name', value: 'account_name', type: 'string' },
          { label: 'Campaign ID', value: 'campaign_id', type: 'string' },
          { label: 'Campaign name', value: 'campaign_name', type: 'string' },
          { label: 'Ad group ID', value: 'ad_group_id', type: 'string' },
          { label: 'Ad group name', value: 'ad_group_name', type: 'string' },
          { label: 'Ad ID', value: 'ad_id', type: 'string' },
          { label: 'Ad name', value: 'ad_name', type: 'string' },
          { label: 'Ad title', value: 'ad_title', type: 'string' },
          { label: 'Ad status', value: 'ad_status', type: 'string' },
          { label: 'Ad review status', value: 'ad_review_status', type: 'string' }
        ],
        defaultValue: [
          {
            name: 'Paid Search - Brand',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'brand'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Generic',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'generic'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'nonbrand'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'chatgptAdsMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in ChatGPT Ads.',
        required: false,
        mutable: true,
        dimensions: [
          { label: 'Account ID', value: 'account_id', type: 'string' },
          { label: 'Account name', value: 'account_name', type: 'string' },
          { label: 'Campaign ID', value: 'campaign_id', type: 'string' },
          { label: 'Campaign name', value: 'campaign_name', type: 'string' },
          { label: 'Ad group ID', value: 'ad_group_id', type: 'string' },
          { label: 'Ad group name', value: 'ad_group_name', type: 'string' }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'denmark' },
                { operator: 'contains', dimension: 'account_name', value: 'dk' },
                { operator: 'contains', dimension: 'campaign_name', value: 'denmark' },
                { operator: 'contains', dimension: 'campaign_name', value: '-dk-' }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'sweden' },
                { operator: 'contains', dimension: 'account_name', value: 'se' },
                { operator: 'contains', dimension: 'campaign_name', value: 'sweden' },
                { operator: 'contains', dimension: 'campaign_name', value: '-se-' }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'norway' },
                { operator: 'contains', dimension: 'account_name', value: 'no' },
                { operator: 'contains', dimension: 'campaign_name', value: 'norway' },
                { operator: 'contains', dimension: 'campaign_name', value: '-no-' }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'finland' },
                { operator: 'contains', dimension: 'account_name', value: 'fi' },
                { operator: 'contains', dimension: 'campaign_name', value: 'finland' },
                { operator: 'contains', dimension: 'campaign_name', value: '-fi-' }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'germany' },
                { operator: 'contains', dimension: 'account_name', value: 'de' },
                { operator: 'contains', dimension: 'campaign_name', value: 'germany' },
                { operator: 'contains', dimension: 'campaign_name', value: '-de-' }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                { operator: 'contains', dimension: 'account_name', value: 'global' },
                { operator: 'contains', dimension: 'campaign_name', value: 'global' }
              ]
            }
          }
        ]
      }
    ],
    other: [
      {
        id: 'ga4MigrationDate',
        type: 'date',
        label: 'GA4 Migration Date',
        helperText:
          'The date where you switched to GA4. Used to determine when to change reporting numbers from UA to GA4.',
        required: false,
        defaultValue: '2023-06-30',
        mutable: true
      },
      {
        id: 'targetCurrency',
        type: 'dropdown',
        label: 'Target Currency',
        helperText: 'The currency to transform all currency-based columns (cost, revenue, etc) to.',
        required: true,
        defaultValue: 'EUR',
        mutable: true
      },
      {
        id: 'alvieAttributionModels',
        type: 'alvie_attribution_model_selector',
        label: 'Attribution Models',
        helperText: 'The attribution models to use for your reports.',
        required: false,
        mutable: true
      }
    ]
  }
}

export default config
